import script from "./MarkCooperate.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkCooperate.vue?vue&type=script&setup=true&lang=js"

import "./MarkCooperate.vue?vue&type=style&index=0&id=a2ba2f6a&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2ba2f6a"]])

export default __exports__